<section class="projects-area pb-70">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <h2>{{sectionTitleContent.title}}</h2>
      </div>
    }

    <div class="row">
      @for (singleProjectsContent of singleProjectsBox; track singleProjectsContent) {
        <div class="col-lg-4 col-md-6">
          <div class="single-projects-box">
            <div class="image">
              <img [src]="singleProjectsContent.img" [alt]="singleProjectsContent.title">
              <a routerLink="/{{singleProjectsContent.link}}" class="link-btn"><i class='{{singleProjectsContent.icon}}'></i></a>
            </div>
            <div class="content">
              <h3><a routerLink="/{{singleProjectsContent.link}}">{{singleProjectsContent.title}}</a></h3>
              <span>{{singleProjectsContent.subTitle}}</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>